import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndefinedErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 6,
			width: 20,
			height: 20,
			rx: 10,
			fill: "#CCCCCC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.75,
			y: 9.75,
			width: 2.5,
			height: 7.5,
			rx: 1.25,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.75,
			y: 19.2053,
			width: 2.5,
			height: 2.5,
			rx: 1.25,
			fill: "white"
		})
	]
});
export default SvgUndefinedErrorIcon;
